import React, {useState, useEffect} from 'react';

import { Section2,SectionTitle, SectionDesc, SliderCard1 } from "../components/reuseable"
import { PopupLarge } from "../components/reuseable/popup"
import Carousel from "../components/reuseable/carousel"

import { useAuth } from "../app/context";

const SkillsTechnical = () =>{

  let { isLoaded,skills, translations } = useAuth();

  const [showPopup, setShowPopup] = useState(false);
  const [skillIndex, setSkillIndex] = useState("");


  const openModal = (key, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setSkillIndex(key);
    setShowPopup(true);
  };

  const closeModal = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    setShowPopup(false);
    setSkillIndex("");
  };
  
  
  return(
    <Section2 id="skills">
      <SectionTitle title={translations.skills.title} ts="1"/>
      {!!isLoaded && <SectionDesc value={translations.skills.description}/>}

      {!!isLoaded && <div className="block-full mt-40 sm:mt-48">
        <Carousel
          dragable= {true}
          dots= {true}
          autoplay= {true}
          autoplayHoverPause= {true}
          autoplayTimeout= {4000}
          smartSpeed= {500}
          responsive= {{
            0 : {items: 1,margin:24},
            768 : {items: 2,margin:24},
            992 : {items: 3,margin:32},
          }}
        >
          {Object.entries(skills).map(([key, skill]) => (
            <SliderCard1
              className="gradient-bc-1 py-6"
              key={key} 
              onClick={(e) => openModal(key, e)}
            >
              <div className="flex-row-full items-start">
                <div className="flex-row-50 h-50 items-center justify-center shrink-0 fs-24 color-white br-12 mr-16 shadow-md" style={{background: "var(--gradient-secondary)"}}>
                  {skill.icon}
                </div>
                <div className="block-full shrink-1 text-left">
                  <div className="block-full font-inter fw-600 fs-20 lh-24 md:fs-24 md:lh-30 color-header-3 mb-4">{skill.title}</div>
                  <div className="block-full font-inter fw-500 fs-14 lh-20 color-muted">{skill.description}</div>
                </div>
              </div>
              <div className="flex-row-full wrap-wrap gap-8 mt-16">
                {skill.items.slice(0, 4).map((tech, index) => (
                  <div key={index} className="block-max br-8 overflow-hidden" key={index}>
                    <div className="block-ful absolute inset-0 bg-highlight-2 opacity-10">&nbsp;</div>
                    <div className="block-full absolute inset-0 bw-1 bs-solid br-8 bc-highlight-2 opacity-20">&nbsp;</div>
                    <span className="block-max color-accent fs-12 fw-500 px-16 py-4">{tech}</span>
                  </div>
                ))}
                {skill.items.length > 4 && (
                  <div className="block-max br-8 overflow-hidden">
                    <div className="block-full absolute inset-0 bg-highlight-2 opacity-10">&nbsp;</div>
                    <div className="block-full absolute inset-0 bw-1 bs-solid br-8 bc-highlight-2 opacity-20">&nbsp;</div>
                    <span className="block-max color-accent fs-12 fw-500 px-16 py-4">+{skill.items.length - 4} more</span>
                  </div>
                )}
              </div>
              <div className="block-full font-inter fw-400 fs-12 lh-16 color-navy-deep mt-16 text-center color-accent" style={{fontStyle: "italic"}}>
                Click to learn more →
              </div>
            </SliderCard1>
          ))}
        </Carousel>
      </div>}



      {!!showPopup && !!isLoaded &&  <PopupLarge onClose={closeModal}>
          <div className="block-full fs-30 lh-36 sm:fs-36 sm:lh-40 mb-8 fw-700 font-inter color-header-1">{skills[skillIndex].title}</div>
          <div className="block-full fs-16 lh-24 font-inter color-soft">{skills[skillIndex].description}</div>

          <div className="block-full fs-24 lh-30 sm:fs-28 sm:lh-36 mb-4 mt-24 fw-600 font-inter color-header-2">Simple Explanation</div>
          <div className="block-full fs-16 lh-24 font-inter color-soft">{skills[skillIndex].simpleExplanation}</div>


          <div className="block-full fs-24 lh-30 sm:fs-28 sm:lh-36 mb-4 mt-24 fw-600 font-inter color-header-2">Technologies & Tools</div>
          
          {skills[skillIndex].items.map((tech,i) => 
            <div className="block-full fw-500 fs-16 lh-28 font-inter color-soft" key={i}>{tech}</div>
          )}
      </PopupLarge>}
    </Section2>
  )
}

export default SkillsTechnical;
